import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {Button, Heading} from '@primer/react'
import {useState} from 'react'

import {LabelCreate} from './LabelCreate'
import {LabelList} from './LabelList'
import {SearchBar} from './LabelSearchBar'
import type {RepositoryResult} from './repository-label-index-page-query-types'
import styles from './RepositoryLabel.module.css'

type RepositoryLabelsInternalFragment = RelayCompat<
  Pick<RepositoryResult, 'id' | 'nameWithOwner' | 'labels' | 'isWritable' | 'viewerCanPush'>
>

type RepositoryLabelsInternalProps = {
  repository: RepositoryLabelsInternalFragment
}

export function RepositoryLabelsInternal({repository}: RepositoryLabelsInternalProps) {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false)

  const data = repository

  return (
    <>
      <div className={styles.middlePaneWrapper}>
        <div className={styles.header}>
          <div className={styles.titleGroup}>
            <SidebarPageLayout.SidebarTrigger />
            <Heading as="h1" className={styles.heading}>
              Labels
            </Heading>
          </div>
          {data.viewerCanPush && (
            <Button variant="primary" onClick={() => setIsCreateDialogOpen(true)}>
              New label
            </Button>
          )}
        </div>
        <SearchBar />
        <ErrorBoundary fallback={<div>Oops we could not load the labels</div>}>
          <LabelList repository={data} onCreateLabel={() => setIsCreateDialogOpen(true)} />
        </ErrorBoundary>
      </div>
      <LabelCreate repository={data} isOpen={isCreateDialogOpen} onClose={() => setIsCreateDialogOpen(false)} />
    </>
  )
}
